import r from "react";

var a = function a(t) {
  var e = r.useRef(t);
  return e.current = t, r.useCallback(function () {
    return e.current.apply(e, arguments);
  }, [e]);
};

export { a as useEvent };